import {trimEnd} from 'lodash';

interface NumberUtilsType {
  roundToWantedDecimals: (numberToRound: number, digits: number, trimDecimals?: boolean) => number;
  lerp: (t: number, x: number, y: number) => number;
  getLerpTime: (result: number, x: number, y: number) => number;
  clamp: (x: number, min: number, max: number) => number;
}

const NumberUtils: NumberUtilsType = {
  /**
   * Round number to wanted decimals.
   *
   * @param numberToRound  Number to round.
   * @param digits Wanted decimals.
   * @param trimDecimals Determine if zero decimals at the end should be trimmed.
   * @return Round number.
   */
  roundToWantedDecimals(numberToRound, digits, trimDecimals = true) {
    let result: number | string = numberToRound;
    const decimals = digits || 0;
    let negative = false;
    if (numberToRound < 0) {
      negative = true;
      result *= -1;
    }
    const multiplicator = 10 ** decimals;
    result = parseFloat((result * multiplicator).toFixed(11));
    result = (Math.round(result) / multiplicator).toFixed(decimals);
    if (negative) {
      result = (+result * -1).toFixed(decimals);
    }
    const strResult = `${result}`;
    if (trimDecimals && strResult.indexOf('.') !== -1) {
      result = trimEnd(strResult, '0');
      result = trimEnd(result, '.');
    }
    return +result;
  },
  lerp(t, x, y) {
    return (1 - t) * x + t * y;
  },
  getLerpTime(result, x, y) {
    return this.clamp((result - x) / (y - x), 0, 1);
  },
  clamp(x, min, max) {
    return Math.min(Math.max(min, x), max);
  },
};

export default NumberUtils;
